import { Form, Row, Col, FloatingLabel } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectUserData } from "../../../redux/reducer/user/userSlice";
import {
    setPageData,
    selectPageData,
    searchAgreeDataAsync,
    selectSearchData,
    setSearch,
} from "../../../redux/reducer/agree/agreeSliceS";

//---------------------------------------------------

export default function SearchByStatus() {
    //redux
    const dispatch = useAppDispatch();
    const { access_token } = useAppSelector(selectUserData);
    const searchData = useAppSelector(selectSearchData);
    const pageData = useAppSelector(selectPageData);

    //onchange
    const onChangeStatus = (ev: any) => {
        const { value } = ev.target;
        const search = { ...searchData, status: value };
        dispatch(setSearch(search));

        if (pageData > 1) dispatch(setPageData(0));
        dispatch(
            searchAgreeDataAsync({
                data: {
                    driver: { ps: "S" },
                    search,
                },
                access_token,
            })
        );
    };

    return (
        <Form>
            <Row className="g-0">
                <Col sm>
                    <FloatingLabel label="Status">
                        <Form.Select id="active" onChange={onChangeStatus}>
                            <option value="all">Wszystkie</option>
                            <option value="pointActive">Wystawione w Punkcie</option>
                            <option value="allegroActive">Wystawione na Allegro</option>
                            <option value="pointSold">Sprzedane w Punkcie</option>
                            <option value="allegroSold">Sprzedane na Allegro</option>
                        </Form.Select>
                    </FloatingLabel>
                </Col>
            </Row>
        </Form>
    );
}
